var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"title-center-container",style:({
    fontFamily: _vm.content.textStyle.fontFamily || '',
    fontSize: (_vm.content.textStyle.fontSize + 'rem') || '',
    lineHeight: (_vm.content.textStyle.lineHeight + 'rem') || '',
    textIndent: (typeof _vm.content.textStyle.textIndent === 'string') ? _vm.content.textStyle.textIndent :
      (typeof _vm.content.textStyle.textIndent === 'number') ? (_vm.content.textStyle.textIndent + 'rem') : '',
    fontWeight: _vm.content.textStyle.fontWeight || '',
    textDecoration: _vm.content.textStyle.underline === 1 ? 'underline' : '',
    fontStyle: _vm.content.textStyle.fontItalic === 1 ? 'italic' : '',
    textAlign: _vm.content.textStyle.textAlign || '',
    color: _vm.content.textStyle.color || '',
    backgroundColor: _vm.content.textStyle.backgroundColor || '',
    backgroundImage: _vm.content.textStyle.backgroundImage ? ("url(" + (_vm.content.textStyle.backgroundImage) + ")") : '',
  }),attrs:{"id":_vm.content.key}},[_c('span',{staticClass:"title-text",attrs:{"id":((_vm.content.key) + "-1")}},[_c('span',{attrs:{"id":((_vm.content.key) + "-1-1")},domProps:{"innerHTML":_vm._s(_vm.content.shortText)}}),_c('span',{attrs:{"id":((_vm.content.key) + "-1-2")},domProps:{"innerHTML":_vm._s(_vm.content.text)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }